export const replaceHelmetTokens = (str: string | null, tokens: string | null, defaultValue = "") => {
  // Disabling this as not sure if the string can be undefined

  if (str == null) {
    return str ?? defaultValue;
  }

  if (tokens == null) {
    return str;
  }

  let updatedValue = str;

  const replaceToken = (token: string, value: string) => {
    const tokenRegExp = new RegExp(`{{${token}}}`, "g");
    updatedValue = updatedValue.replace(tokenRegExp, () => value);
  };

  const replaceTokensRecursively = (tokenObject: string, parentKey = "") => {
    if (!tokenObject) {
      return "";
    }
    for (const [key, value] of Object.entries(tokenObject)) {
      const token = parentKey ? `${parentKey}.${key}` : key;
      if (typeof value === "object") {
        replaceTokensRecursively(value, token);
      } else {
        replaceToken(token, value);
      }
    }
  };

  replaceTokensRecursively(tokens);

  // Replace any remaining tokens with the default value
  updatedValue = updatedValue.replace(/{{[a-zA-Z0-9._]+}}/g, () => defaultValue);
  return updatedValue;
};
